import { Box, BoxProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import palette from '@ui/palette';

export interface CardProps extends BoxProps {
  selected?: boolean;
  children: React.ReactNode;
}

const Card = (props: CardProps) => {
  const { selected, className, children, ...rest } = props;
  const { classes, cx } = useStyles();

  return (
    <Box
      className={cx(classes.root, className)}
      data-selected={selected}
      {...rest}
    >
      {children}
    </Box>
  );
};

const useStyles = makeStyles()(theme => ({
  root: {
    boxSizing: 'border-box',
    backgroundColor: palette.gray_1000,
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1.5, 2),
    color: palette.gray_0,
    display: 'grid',
    alignContent: 'space-between',
    '&[data-selected="true"]': {
      outline: `1px solid ${palette.gray_400}`,
    },
    '&:hover': {
      backgroundColor: palette.gray_900,
      cursor: 'pointer',
    },
  },
}));

export default Card;
